/**
 * useSeesHidden - may this screen be told what the table keeps from players (2026-10-22, plan muster)?
 *
 * The GM, or solo play, which has nobody to hide anything from: the codebase's one rule for it (`rulesAlone` in
 * useShellDomainAttack, `useWoundDisplay`). The muster's orphan mark and the squad chips' "no controller here" note
 * read it: a player never receives a hidden figure, so to them a hidden controller looks absent, and the note would
 * say one exists.
 *
 * Reads the context directly, as `useWoundDisplay` does: a leaf readout may render with no session around it (a unit
 * test, a preview), and no session means nobody to hide from.
 */
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';

interface SessionSlice {
  isGm?: boolean;
  sessionId?: string | null;
}

export function useSeesHidden(): boolean {
  // Asserted at the boundary: SessionContext is a `.jsx` module created with `createContext(null)`.
  const ctx = useContext(SessionContext) as SessionSlice | null;
  return !ctx?.sessionId || !!ctx.isGm;
}
